import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PortalkonfigurationDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/portalkonfiguration-display-model';
import { LocalizedTextDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/localized-text-display-model';
import { FoerderprogrammDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/foerderprogramm-display-model';
import { I18nService } from '@/core/services/i18nService';
import { AusschreibungDisplayModel, GlobalEnumsAceSortierungausschreibungskacheln } from '@/api/model-index';

@Component({
  selector: 'app-ausschreibung-overview',
  templateUrl: './ausschreibung-overview.component.html',
  styleUrls: ['./ausschreibung-overview.component.scss']
})
export class AusschreibungOverviewComponent implements OnInit {
  public portalkonfiguration : PortalkonfigurationDisplayModel;
  public foerderprogramme : FoerderprogrammDisplayModel[];

  constructor(protected route: ActivatedRoute,
    protected languageservice: I18nService) {
  }

  ngOnInit(): void {
    this.portalkonfiguration = this.route.snapshot.data.portalkonfiguration;
    this.foerderprogramme = this.route.snapshot.data.foerderprogramme;
  }

  public get willkommenstext(): string {
    let willkommenstext: LocalizedTextDisplayModel | undefined = this.languageservice.getCurrentLocalizedTextDisplayModel(this.portalkonfiguration.willkommenstexte);

    return willkommenstext?.text ?? "";
  }

  public get infotextUebersicht(): string {
    let infotextUebersicht: LocalizedTextDisplayModel | undefined = this.languageservice.getCurrentLocalizedTextDisplayModel(this.portalkonfiguration.infotexteUebersicht);

    return infotextUebersicht?.text ?? "";
  }

  public isNoEntryMessageVisible(index: number): boolean {
    if (! this.foerderprogramme[index])
      return true;
    else if (! this.foerderprogramme[index].ausschreibungen?.length)
      return true;

    return false;
  }

  public get sortedAusschreibungen(): AusschreibungDisplayModel[] {
    let sortedAusschreibungen: AusschreibungDisplayModel[] = [];

    this.foerderprogramme.forEach(foerderprogramm => {
      if (foerderprogramm.ausschreibungen)
        sortedAusschreibungen.push(...foerderprogramm.ausschreibungen);
    });

    sortedAusschreibungen.sort((a, b) => {
      const nameA = (a.name || '').toLowerCase();
      const nameB = (b.name || '').toLowerCase();
      return nameA.localeCompare(nameB);
    });

    return sortedAusschreibungen;
  }

  public get sortierungAusschreibungskacheln(): GlobalEnumsAceSortierungausschreibungskacheln {
    if (! this.portalkonfiguration.sortierungAusschreibungskacheln)
      return GlobalEnumsAceSortierungausschreibungskacheln.Forderprogramm;

    return this.portalkonfiguration.sortierungAusschreibungskacheln;
  }

  public get sortByFoerderprogramme(): boolean {
    return this.sortierungAusschreibungskacheln == GlobalEnumsAceSortierungausschreibungskacheln.Forderprogramm;
  }

  public get sortByAusschreibungsname(): boolean {
    return this.sortierungAusschreibungskacheln == GlobalEnumsAceSortierungausschreibungskacheln.Ausschreibungsname;
  }
}
